import "./styles.css";
import * as React from "react";
import { memo } from "react";
import { Tree, NodeRendererProps, CreateHandler, RenameHandler, MoveHandler, DeleteHandler } from "react-arborist";
import {
    FaFolderOpen,
    FaFolder,
    FaFolderPlus as FolderPlus,
    FaTrashAlt as Trash,
    FaScroll as Scroll,
    FaStarOfLife as Changed,
    FaCog as Cog
} from "react-icons/fa";
import {
    FiChevronDown as ChevronDown,
    FiChevronRight as ChevronRight,
    FiFileText as FileText,
    FiEdit2 as Edit,
    FiFilePlus as FilePlus
} from "react-icons/fi";
import classNames from "classnames";
import { IExtraActions, ITreeObjDir, ITreeObj } from "./types";
import { useExtraActions } from "./utils";

const size = 16;
const smallSize = 12;
const color = "#999";
const gray = "#2C2C2C";

interface IconProps {
    isRoot: boolean;
    isSelected: boolean;
    isOpen: boolean;
    nodeType: string;
}
interface OpenProps {
    node: any;
    isOpen: boolean;
}
interface NodeProps {
    node: any;
}


function Icon({ isRoot, isSelected, isOpen, nodeType }: IconProps) {
    if (isRoot) {
        return (
            <Scroll
                className="icon scroll"
                // fillOpacity="0.7"
                color="#81CFFA"
                size={size}
            />
        );
    }
    switch (nodeType) {
        case "sub":
            return (
                <Cog
                    className="icon cog"
                    stroke={isSelected ? gray : "#333"}
                    strokeOpacity={isSelected ? "0.8" : "0.4"}
                    size={size}
                />
            );
            break;
    }
    return (<div></div>);
}
function EditIcon({ node }: NodeProps) {
    if (node && node.data && node.data.editing ) {
        return (
            <Edit className="icon edit" size={smallSize} color={gray} />
        );
    }
    return (<div></div>);
}
function ChangedIcon({ node }: NodeProps) {
    if (node && node.data && node.data.changed) {
        return (
            <Changed className="icon edit" size={smallSize} color={gray} />
        );
    }
    return (<div></div>);
}

function TrashIcon({ node }: NodeProps) {
    if (node && node.data && node.data.remove) {
        return (
            <Trash className="icon edit" size={smallSize} color={gray} />
        );
    }
    return (<div></div>);
}


function OpenIcon({ node, isOpen }: OpenProps) {
    if (node.isLeaf) {
        return (<></>);
    }
    if (isOpen) {
        return (
            <ChevronDown
                onClick={(e : any) => node.toggle(e)}
                className="icon open"
                // fillOpacity="0.7"
                color="#81CFFA"
                size={size}
            />
        );
    } else {
        return (
            <ChevronRight
                onClick={(e : any) => node.toggle(e)}
                className="icon closed"
                // fillOpacity="0.7"
                color="#81CFFA"
                size={size}
            />
        );
    }
}

type FormProps = Pick<
    NodeRendererProps<ITreeObj>,
    "node"
    > & {
    defaultValue: string;
};

/*
function RenameForm({ defaultValue, node }: FormProps) {
    const inputProps = {
        defaultValue,
        autoFocus: true,
        onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            node.submit(e.currentTarget.value);
        },
        onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
            switch (e.key) {
                case "Enter":
                    node.submit(e.currentTarget.value);
                    break;
                case "Escape":
                    node.reset();
                    break;
            }
        }
    };
    return <input type="text" {...inputProps} />;
}
*/

type TitleActionsProps<T extends ITreeObj> = Pick<
    NodeRendererProps<T extends ITreeObj ? any : any>,
    "node" 
> & {
    isRoot: boolean;
    extraActions: IExtraActions;
};

function TitleActions<T extends ITreeObj>(props: TitleActionsProps<T>) {
    const { node, isRoot, extraActions } = props;
    /*
    if (node.state.isEditing) {
        return <RenameForm defaultValue={node.data.name} node={node} />; //{...handlers} />;
    }
    */
    const rootActions = isRoot ? (
        <>
            <button onClick={node.edit} title="Rename">
                <Edit size={smallSize} color={gray} />
            </button>
            <button onClick={() => extraActions.addFile(node.data.id)} title="Add File">
                <FilePlus size={smallSize} color={gray} />
            </button>
            <button
                onClick={() => extraActions.addFolder(node.data.id)}
                title="Add Directory"
            >
                <FolderPlus size={smallSize} color={gray} />
            </button>
        </>
    ) : null;
    return (
        <span className="arborist-row-title">
            <span className={"dependency-title-" + node.data.type}>{node.data.name}</span>
            <span className="actions">
                {rootActions}
                <button onClick={() => console.log("huh") } title="Delete">
                    <Trash size={smallSize} color={gray} />
                </button>
            </span>
        </span>
    );
}

// const selectOnClick1 = { selectOnClick: true };

export default function Node<T extends ITreeObj>(props: NodeRendererProps<T>) {
    const { style, node, tree, dragHandle } = props;
    const isRoot = node.data.type === "root";
    const isOpen = !!node.state.isOpen;
    const extraActions = useExtraActions();
    var indent = "0px";
    if (!isRoot) {
        var numIndent = node.level * 15;
        if (node.isLeaf) {
            numIndent += 15;
        }
        indent = numIndent + "px";
    }
    return (
        <div
            ref={dragHandle}
            className={classNames("arborist-row", node.state)}
            //style={rowStyle}
            //onClick={(e) => node.handleClick(e)}
            // @ts-ignore
            onClick={(e) => node.handleClick(e)}
        >
            <div className="arborist-row-contents" style={{paddingLeft:indent}}>
                <OpenIcon
                    node={node}
                    isOpen={isOpen}
                />
                <EditIcon
                    node={node}
                />
                <ChangedIcon
                    node={node}
                />
                <TrashIcon
                    node={node}
                />
                <Icon
                    isRoot={isRoot}
                    isOpen={isOpen}
                    isSelected={node.state.isSelected}
                    nodeType={node.data.type}
                />
                <TitleActions
                    isRoot={isRoot}
                    node={node}
                    extraActions={extraActions}
                />
            </div>
        </div>
    );
}
